import React, {useEffect, useState} from "react";
import Layout from "./Layout";
import ReactMarkdown from 'react-markdown'
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import rehypeHighlight from "rehype-highlight";
import "highlight.js/styles/dark.css";
import blog_files from "./Data/blogs_files";
import BuyMeACoffee from "./BuyMeACoffee";


const Blog = (props) => {
    const [post, setPost] = useState('');
    const [filename, setFilename] = useState('');

    const getFileName = () => {
        let param = props.match.params.blog_name;
        let data = param.split("-");
        let temp_file = data[0];

        setFilename(temp_file);
    };

    const getFile = () => {
        getFileName();

        const file = blog_files[filename];

        fetch(file)
            .then(resp => {
                return resp.text()
            })
            .then(data => {
                setPost(data);
            });
    }

    useEffect(() => {
        getFile()
    }, [post]);

    return (
        <Layout>
            <div style={{margin: '10% 5%', fontSize: '24px', textAlign: 'left', color: 'white'}}>
                <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw,rehypeHighlight]}>
                    {post}
                </ReactMarkdown>
            </div>
            <BuyMeACoffee />
        </Layout>
    )
};

export default Blog;